import axios from 'axios'
import type { Contact } from '../../ContactManagement/types'

/**
 * APIs for project-level Ironworker membership (Organization only)
 */
export const projectMembersApi = {
  /** List contacts assigned to a project */
  list: (projectId: string): Promise<Contact[]> =>
    axios
      .get<Contact[]>(
        `/api/myteconstruction/projects/${projectId}/ironworkers`
      )
      .then((res) => res.data),

  /** Add multiple contacts (ironworkers) to a project */
  add: (
    projectId: string,
    contactIds: string[]
  ): Promise<{ projectId: string; contactId: string }[]> =>
    axios
      .post<{ projectId: string; contactId: string }[]>(
        `/api/myteconstruction/projects/${projectId}/ironworkers`,
        { contactIds }
      )
      .then((res) => res.data),

  /** Remove a contact from a project */
  remove: (
    projectId: string,
    contactId: string
  ): Promise<void> =>
    axios
      .delete<void>(`/api/myteconstruction/projects/${projectId}/ironworkers/${contactId}`)
      .then((res) => res.data),
}